import {
  useState,
  createContext,
  useContext,
  useMemo,
  useEffect,
} from 'react';
import { useTimeline } from 'hooks/timeline';
import { getRefreshTokenCookie, getItem, removeRefreshTokenCookie, removeAccessTokenCookie } from "lib/Storage";
import { useExploreTimelines, useTimelines } from './timeline';
import { useTranslation } from 'react-i18next';  

export const InputContext = createContext(null);

export function InputProvider({ children }) { 

  const queryParams = new URLSearchParams(window.location.search);
  const fr = queryParams.get("fr");
  const tId = queryParams.get("tl");
  const b = queryParams.get("b");
  const bare = Number(b);
  const initBare = !isNaN(bare) ? bare : 0;
  
  const { i18n } = useTranslation();
  const { mutate: fetchTimelines, data: fetchTimelinesResponse } = useTimelines();
  const {mutate: exploreTimelines, data: exploreTimelinesResponse} = useExploreTimelines();
  const { mutateAsync: getTimeline } = useTimeline();
  const [isLoggedIn, setIsLoggedIn] = useState(!!getRefreshTokenCookie());
  const [inputType, setInputType] = useState('en');
  const [strInput, setStrInput] = useState('');
  const [play, setPlay] = useState(false);
  const [timelines, setTimelines] = useState([]);
  const [currentTimeline, setCurrentTimeline] = useState({});
  const [currentFrequency, setCurrentFrequency] = useState(0);
  const [activeTab, setActiveTab] = useState('2');
  const [currentBare, setCurrentBare] = useState(initBare);
  const [currentTimelineId, setCurrentTimelineId] = useState(0);
  const [sharedFaalId, setSharedFaalId] = useState('');
  const [sharedTimeline, setSharedTimeline] = useState(!!tId);
  const [keyTimelineId, setKeyTimelineId] = useState("");
  const [currentTimelineIndex, setCurrentTimelineIndex] = useState(0);
  const [direction, setDirection] = useState(getItem('dir'));
  const [currentTimeMusic, setCurrentTimeMusic] = useState()
  const [manualCurrentTimeMusic, setManualCurrentTimeMusic] = useState(null);
  const [expand, setExpand] = useState(false);
  const [frequencyMap, setFrequencyMap] = useState({});
  const [timelinesData, setTimelinesData] = useState([]);
  const [ownersTitle, setOwnersTitle] = useState({});
  const [frequencyData, setFrequencyData] = useState([]);
  const [activeSlideArtistName, setActiveSlideArtistName] = useState();
  const [trackFetchingLoading, setTrackFetchingLoading] = useState(false);
  const [keepPlay, setKeepPlay] = useState(false);
  const [userInfo, setUserInfo] = useState(false);

  
  useEffect(() => {
    if(!tId || !fr) return;

    (async () => {

    try {
      const {status, timeline} = await getTimeline(tId);
      if (status !== "OK") throw new Error('Error getting Timeline');
      setSharedTimeline(true);
      setTimelines([timeline])
      setCurrentTimelineId(timeline.timelineId);
      setCurrentFrequency(timeline.frequency);
      setCurrentTimelineIndex(0);
      if(!isNaN(bare) && bare < timeline.timestamps.length) {
        const bareTime = timeline.timestamps[bare-1];
        setManualCurrentTimeMusic(bareTime);
        setInputType('bare');
      }
      
    } catch(e) {
      console.log(e)
    }
  })();
  /* eslint-disable react-hooks/exhaustive-deps */
  },[getTimeline]);
  
  useEffect(() => {
    i18n.changeLanguage(getItem('lng'));
  }, [i18n]);
  
  useEffect(() => {
    if(!isLoggedIn)return;
    exploreTimelines({keyTimelineId,band:"original"},{
      onError: (err) => console.log("Error!: ", err)
    })
  }, [exploreTimelines, fetchTimelines, isLoggedIn, keyTimelineId]);

  useEffect(() => {
    if (!isLoggedIn) {
      removeRefreshTokenCookie();
      removeAccessTokenCookie();
    }
  }, []);

  useEffect(() => {
    if (!timelines) return;
    let frequencyMap = {};
    let ownerNames = {};

    for (let timeline of timelines) {
      if (ownerNames[timeline.frequency])
        frequencyMap[timeline.frequency] = [
          ...frequencyMap[timeline.frequency],
          timeline,
        ];
      else {
        ownerNames[timeline.frequency] = timeline.persianOwnerTitle;
        frequencyMap[timeline.frequency] = [timeline];
      }
    }

    let data = [];
    for (let frequency in ownerNames) {
      data.push({ text: ownerNames[frequency], actionValue: frequency });
    }
    setOwnersTitle(ownerNames);
    setFrequencyMap(frequencyMap);
    setFrequencyData(data);
  }, [timelines]);

  useEffect(() => {
    if(exploreTimelinesResponse?.status === "OK" && exploreTimelinesResponse?.timelines){
      let newTimelines = exploreTimelinesResponse.timelines;

      const timelineIndex = newTimelines.findIndex((item) => (item.timelineId === currentTimelineId));
            
      if(timelineIndex === -1 && currentTimeline?.timelineId) {
        newTimelines.push(currentTimeline);
      }

      setTimelines(newTimelines);    
    }
  },[exploreTimelinesResponse, setTimelines, currentTimeline, currentTimelineId])

  useEffect(() => {
    if (fetchTimelinesResponse?.status === "OK" && fetchTimelinesResponse?.timelines) {
      setTimelines(fetchTimelinesResponse.timelines);
    }
  }, [fetchTimelinesResponse, setTimelines]);

  useEffect(() => {

    const timeline = timelines.find((item) => item.timelineId === currentTimelineId);

    if(timeline){
      setCurrentTimeline(timeline);
      setCurrentFrequency(timeline.frequency);
    }

    const timelineIndex = timelines.filter((item) => item.frequency === currentFrequency)
    .findIndex((item) => item.timelineId === currentTimelineId);

    if (timelineIndex !== -1 && timelines.length-1 > timelineIndex) {
      setCurrentTimelineIndex(timelineIndex)
    }






    // let currentTimelineIndex = timelines
    // .findIndex((item) => item.timelineId === currentTimelineId);
   
    // if (currentTimelineIndex !== -1 && timelines.length) {
    //   const currentTimeline = timelines[currentTimelineIndex];
    //   setCurrentTimelineIndex(currentTimelineIndex)
    //   setCurrentFrequency(currentTimeline.frequency);
    //   setCurrentTimeline(currentTimeline);
    // }
  }, [currentTimelineId, timelines]);

  useEffect(() => {
    let timelinesData = [];
    if (
      !frequencyMap ||
      !Object.prototype.hasOwnProperty.call(frequencyMap, currentFrequency)
    )
      return;
    for (let timeline of frequencyMap[currentFrequency]) {
      timelinesData.push({
        text: timeline.persianTimelineTitle,
        actionValue: timeline.timelineId,
      });
    }
    setTimelinesData(timelinesData);
  }, [currentFrequency, frequencyMap]);

  useEffect(()=>{
    if(play){
      setInputType("num")
    }
  },[play])
  
  const memoedValue = useMemo(() => {
    const resetSelectedTimeline = ()=>{
      setCurrentFrequency()
      setCurrentTimeline({});
      setCurrentBare(0);
      setCurrentTimelineId(0);
      setCurrentFrequency(0);
    };

    const handleChangeTimeline = (i) => {
      const currentTimeline = timelines[i];
      let localCurrentTimelineIndex = timelines
        .filter((timeline) => timeline.frequency === currentTimeline.frequency)
        .findIndex(({ timelineId }) => timelineId === currentTimeline.timelineId);
      setCurrentTimelineId(currentTimeline.timelineId);
      setCurrentTimelineIndex(localCurrentTimelineIndex);
      setCurrentFrequency(currentTimeline.frequency);
      setCurrentTimeline(currentTimeline);
    };

    const checkCharacter = () => {
      if (!isLoggedIn) {
        return 'number'
      }
    };

    const handleStrInput = (i) => {
      const charIsNaN = isNaN(parseInt(i));
      if(charIsNaN && checkCharacter() === 'number'){
        return false
      }
      const newStr = strInput.concat(i);
      setStrInput(newStr);
      return true
    };

    const handleClearStr = () => {
      setStrInput(pre => pre.slice(0, -1));
    };

    const changePlayMood = () => {
      if(trackFetchingLoading) return;
      setPlay(!play);
    };

    const nextBare = () => {
      let bareCount = currentTimeline.timestamps.length;
      if (currentBare < bareCount - 1)
        setCurrentBare(currentBare + 1);
    };

    const previousBare = () => {
      if (currentBare > 1)
        setCurrentBare(currentBare - 1)
    };

    const previousTimeline = ()=> {
      let currentTimelineIndex = timelines.findIndex(({ timelineId }) => timelineId === currentTimelineId);
      if(currentTimelineIndex === -1 || currentTimelineIndex === 0) return;
      handleChangeTimeline(currentTimelineIndex-1);
      setKeepPlay(true);
    };

    const nextTimeline = ()=> {
      let currentTimelineIndex = timelines.findIndex(({ timelineId }) => timelineId === currentTimelineId);
      if(currentTimelineIndex=== -1 || currentTimelineIndex === timelines.length -1) return;
      handleChangeTimeline(currentTimelineIndex+1);
      setKeepPlay(true);
    };

    return {
      isLoggedIn,
      setIsLoggedIn,
      activeTab,
      setActiveTab,
      inputType,
      setInputType,
      strInput,
      setStrInput,
      handleClearStr,
      previousTimeline,
      nextTimeline,
      currentBare,
      play,
      setPlay,
      setCurrentBare,
      handleStrInput,
      changePlayMood,
      currentTimeline,
      timelines,
      currentTimelineId,
      setCurrentTimelineId,
      nextBare,
      previousBare,
      sharedFaalId,
      setSharedFaalId,
      keyTimelineId,
      setKeyTimelineId,
      currentFrequency,
      setCurrentFrequency,
      currentTimelineIndex,
      setCurrentTimelineIndex,
      resetSelectedTimeline,
      direction,
      setDirection,
      currentTimeMusic,
      setCurrentTimeMusic,
      manualCurrentTimeMusic,
      setManualCurrentTimeMusic,
      expand,
      setExpand,
      frequencyMap,
      timelinesData,
      ownersTitle,
      frequencyData,
      activeSlideArtistName,
      setActiveSlideArtistName,
      trackFetchingLoading,
      setTrackFetchingLoading,
      keepPlay,
      setKeepPlay,
      setTimelines,
      sharedTimeline,
      userInfo,
      setUserInfo,
    };
  },
    [
      isLoggedIn,
      setIsLoggedIn,
      activeTab,
      inputType,
      strInput,
      currentBare,
      play,
      currentTimelineId,
      currentTimeline,
      timelines,
      sharedFaalId,
      setSharedFaalId,
      keyTimelineId,
      setKeyTimelineId,
      currentFrequency,
      setCurrentFrequency,
      currentTimelineIndex,
      setCurrentTimelineIndex,
      direction,
      setDirection,
      currentTimeMusic,
      manualCurrentTimeMusic,
      expand,
      frequencyMap,
      timelinesData,
      ownersTitle,
      frequencyData,
      activeSlideArtistName,
      trackFetchingLoading,
      setTrackFetchingLoading,
      keepPlay,
      setKeepPlay,
      setTimelines,
      sharedTimeline,
      userInfo,
      setUserInfo,
    ],
  );

  return (
    <InputContext.Provider value={memoedValue}>
      {children}
    </InputContext.Provider>
  );
}

export default function useInputKeys() {
  return useContext(InputContext);
}
